/**
 * Calcula el importe en euros para cubrir déficit de oro/platino 999 (g).
 * @returns {{ goldDeficit: number, platinumDeficit: number, goldCost: number|null, platinumCost: number|null, total: number, hasDeficit: boolean, isPartial: boolean }}
 */
export const calcMetalPurchaseCost = (
  goldAvailable,
  platinumAvailable,
  goldEurPerGram,
  platinumEurPerGram
) => {
  const goldDeficit = goldAvailable < 0 ? Math.abs(goldAvailable) : 0;
  const platinumDeficit = platinumAvailable < 0 ? Math.abs(platinumAvailable) : 0;
  const hasDeficit = goldDeficit > 0 || platinumDeficit > 0;

  const goldCost =
    goldDeficit > 0 && goldEurPerGram ? goldDeficit * goldEurPerGram : null;
  const platinumCost =
    platinumDeficit > 0 && platinumEurPerGram
      ? platinumDeficit * platinumEurPerGram
      : null;

  const total = (goldCost ?? 0) + (platinumCost ?? 0);
  const isPartial =
    hasDeficit &&
    ((goldDeficit > 0 && !goldEurPerGram) ||
      (platinumDeficit > 0 && !platinumEurPerGram));

  return {
    goldDeficit,
    platinumDeficit,
    goldCost,
    platinumCost,
    total,
    hasDeficit,
    isPartial,
  };
};

export const formatEuroAmount = (amount) =>
  amount.toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatEuroPerGram = (amount) =>
  `${amount.toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  })}/g`;

export const calcSingleMetalPurchaseCost = (available, eurPerGram) => {
  const deficit = available < 0 ? Math.abs(available) : 0;
  const cost =
    deficit > 0 && eurPerGram ? deficit * eurPerGram : null;

  return {
    deficit,
    cost,
    hasDeficit: deficit > 0,
    priceUnavailable: deficit > 0 && !eurPerGram,
  };
};

export const buildSingleMetalPurchaseTooltip = (metalLabel, cost) => {
  if (!cost.hasDeficit) return `Sin déficit de ${metalLabel.toLowerCase()}`;
  if (cost.cost != null) {
    return `${metalLabel}: ${cost.deficit.toFixed(2)} g → ${formatEuroAmount(cost.cost)}`;
  }
  return `${metalLabel}: ${cost.deficit.toFixed(2)} g (precio no disponible)`;
};

export const buildPurchaseCostTooltip = (cost) => {
  if (!cost.hasDeficit) return "Sin déficit de metal";
  const parts = [];
  if (cost.goldDeficit > 0) {
    parts.push(
      cost.goldCost != null
        ? `Oro: ${cost.goldDeficit.toFixed(2)} g → ${formatEuroAmount(cost.goldCost)}`
        : `Oro: ${cost.goldDeficit.toFixed(2)} g (precio no disponible)`
    );
  }
  if (cost.platinumDeficit > 0) {
    parts.push(
      cost.platinumCost != null
        ? `Platino: ${cost.platinumDeficit.toFixed(2)} g → ${formatEuroAmount(cost.platinumCost)}`
        : `Platino: ${cost.platinumDeficit.toFixed(2)} g (precio no disponible)`
    );
  }
  if (cost.isPartial) {
    parts.push("Importe parcial: falta precio de algún metal");
  }
  return parts.join(" | ");
};
